import { createSlice } from '@reduxjs/toolkit';
import type { NormalizedError } from 'errors/types';
import type { RootState } from 'state/store';

export type InitiateState = {
  isLoading: boolean;
  errors: null | NormalizedError[];
  data: {
    callTimestamp: string | null;
  };
};
export const initialState: InitiateState = {
  isLoading: false,
  errors: null,
  data: {
    callTimestamp: null
  }
};

export const slice = createSlice({
  name: 'initiate',
  initialState,
  reducers: {
    setInitialState: (state) => {
      state.isLoading = initialState.isLoading;
      state.errors = initialState.errors;
      state.data = initialState.data;
    },
    setIsLoading: (state) => {
      state.isLoading = true;
      state.errors = initialState.errors;
    },
    setSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.data.callTimestamp = payload;
      state.errors = initialState.errors;
    },
    setError: (state, { payload }) => {
      state.isLoading = false;
      state.data = initialState.data;
      state.errors = payload;
    }
  }
});

export const {
  setInitialState,
  setIsLoading,
  setSuccess,
  setError
} = slice.actions;

export const selectInitiateSlice = (state: RootState) => state[slice.name];
export const selectInitiateData = (state: RootState) => state[slice.name].data;
export const selectIsLoading = (state: RootState) =>
  selectInitiateSlice(state).isLoading;
export const selectCallTimestamp = (state: RootState) =>
  selectInitiateData(state).callTimestamp;
export const selectErrors = (state: RootState) =>
  selectInitiateSlice(state).errors;

export default slice.reducer;
